<template>
  <div>
    <a-spin :spinning="spinning">
      <a-button v-if="info.is_invoice != 2 && info.pay_type == 1 && info.status == 5" type="primary" class="mb-3"
        @click="applyInvoiceFlag = true" :disabled="info.is_invoice != 5 && info.is_invoice != 0">{{ info.is_invoice !=
          5 && info.is_invoice != 0 ? '已申请发票' : '申请发票' }}</a-button>
      <a-table :dataSource="list" :columns="columns" c :loading="loading" :pagination="false">
        <span slot="status" slot-scope="text, record">
          {{ findByKey(invoiceStatuss, 'id', text, 'name') }}
          {{ record.is_red ? '(已冲红)' : '' }}
        </span>
        <template slot="action" slot-scope="text, record">
          <span>
            <a @click="download(record)" v-if="record.status == 2" class="text-green-500">下载</a>
            <a-divider v-if="record.status == 2" type="vertical"></a-divider>
            <a v-if="record.status == 2" class="text-green-500" @click="preview(record)">预览</a>
          </span>
        </template>
      </a-table>
    </a-spin>
    <a-modal :visible="previewFlag" title="预览" :footer="null" @cancel="previewFlag = false" width="1000px">
      <iframe :src="`${$ossUrl}/pdfjs/build/web/viewer.html?file=${$ossUrl}${previewInfo.invoice_file_src}`"
        style="width: 100%; height: 60vh"></iframe>
    </a-modal>
    <a-modal :visible="applyInvoiceFlag" title="申请开票" @cancel="applyInvoiceFlag = false" @ok="applyinvoiceOk">
      <div class="my-4">
        <a-form>
          <div class="flex flex-col gap-2">
            <a-form-item :label-col="{ span: 6 }" label="开票类型">
              <a-radio-group v-model="value" @change="applyInvoicechange">
                <a-radio :value="false" default-checked> 普票 </a-radio>
                <!-- <a-radio :value="true" default-checked> 专票 </a-radio> -->
              </a-radio-group>
            </a-form-item>
          </div>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { columns } from './_invoice';
import { invoices, invoice_statuss } from '@/api/invoice';
import { findByKey } from '@/utils/tool';
import { downloadUrl } from '@/utils/download';
import { contract, contract_invoice_applye } from '@/api/contract';
export default {
  props: {
    id: Number,
  },
  data() {
    return {
      columns,
      list: [],
      loading: true,
      invoiceStatuss: [],
      spinning: false,
      previewInfo: {},
      previewFlag: false,
      applyInvoiceFlag: false,
      invoiceFlag: true,
      info: {},
      value: false,
    };
  },
  watch: {
    id(a) {
      this.gets();
    },
  },
  async mounted() {
    this.invoiceStatuss = (await invoice_statuss({ current: -1 })).data || [];
    this.gets();
  },
  methods: {
    findByKey,
    async gets() {
      this.loading = true;
      this.list =
        (
          await invoices({
            qp: JSON.stringify({ eq: { contract_id: this.id, status: 2 } }),
            current: -1,
          })
        ).data || [];
      this.info = (await contract(this.id)) || {};
      this.info.invoiceType = false;
      this.loading = false;
    },
    async download(record) {
      this.spinning = true;
      await downloadUrl(
        this.$ossUrl + record.invoice_file_src,
        `${record.contract
          ? record.contract.bidder +
          '-' +
          record.contract.prefix +
          record.contract.code +
          '.pdf'
          : '发票.pdf'
        }`,
      );
      this.spinning = false;
    },
    preview(record) {
      this.previewInfo = record;
      this.previewFlag = true;
    },
    async applyinvoiceOk() {
      if (this.loading == true) {
        return;
      }
      this.loading = true;
      this.info = await contract_invoice_applye(this.info);
      this.loading = false;
      this.applyInvoiceFlag = false;
    },
    applyInvoicechange(e) {
      this.info.invoiceType = e;
    },
  },
};
</script>
